const state = {
    items: [],
    item: {
        name: ''
    }
};

export default state;